import { AuthenticationDetails, CognitoUser, CognitoUserAttribute, CognitoUserPool } from 'amazon-cognito-identity-js'
import { ActionCreator } from 'app/redux/ActionCreator'
import { ActionTypes, IUserAction, IUserState } from 'app/redux/User/reducer'
import { CognitoIdentityServiceProvider } from 'aws-sdk'

class UserActionCreator extends ActionCreator<IUserState, IUserAction> {
  private static GroupName = 'AuthenticatedUsers';
  private static LOCAL_STORAGE_KEY = 'U$3R'
  private static UserPoolId = 'us-east-1_FpHuUpwa9'
  private static AppClientId = '6g39altv4kfqc3mi36iag5sdj1'

  init() {
    try {
      const userJSONStr = localStorage.getItem(UserActionCreator.LOCAL_STORAGE_KEY)
      const user = JSON.parse(userJSONStr) as IUserState

      const data = {
        UserPoolId: UserActionCreator.UserPoolId, // Your user pool id here
        ClientId: UserActionCreator.AppClientId // Your client id here
      };
      const userPool = new CognitoUserPool(data)
      const cognitoUser = userPool.getCurrentUser()

      if (cognitoUser != null) {
        cognitoUser.getSession((err, session) => {
          if (err) {
            localStorage.removeItem(UserActionCreator.LOCAL_STORAGE_KEY)

            this.dispatch(
              { type: ActionTypes.INIT }
            )
            return
          } else {
            this.dispatch(
              { type: ActionTypes.LOGIN, user }
            )
          }
        })
      } else {
        this.dispatch(
          { type: ActionTypes.INIT }
        )
      }
    } catch (noProperLoginData) {
      this.dispatch(
        { type: ActionTypes.INIT }
      )
    }
  }

  login(username: string, token: string) {
    return this.dispatchAsync((getState) => {
      return new Promise((resolve, reject) => {
        const authenticationData = {
          Username: username,
          Password: token,
        }
        const authenticationDetails = new AuthenticationDetails(authenticationData);
        const poolData = {
          UserPoolId: UserActionCreator.UserPoolId, // Your user pool id here
          ClientId: UserActionCreator.AppClientId
        };
        const userPool = new CognitoUserPool(poolData);
        const userData = {
          Username: username,
          Pool: userPool
        }
        const cognitoUser = new CognitoUser(userData);
        cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess(result) {
            const user: IUserState = {
              username,
              token: result.getIdToken().getJwtToken(),
              accessToken: result.getAccessToken().getJwtToken(),
              isInit: true
            }
            const type = ActionTypes.LOGIN
            try {
              const userStr = JSON.stringify(user)
              localStorage.setItem(UserActionCreator.LOCAL_STORAGE_KEY, userStr)
            } catch (e) {
              // tslint:disable-next-line:no-console
              console.error('Unable to save user credentials')
            }
            resolve(
              { type: ActionTypes.LOGIN, user }
            )
          },
          onFailure(err) {
            reject('Incorrect login credentials')
          },
        })
      })
    })
  }

  logout() {
    return this.dispatchAsync((getState) => {
      try {
        localStorage.setItem(UserActionCreator.LOCAL_STORAGE_KEY, null)

        const data = {
          UserPoolId: UserActionCreator.UserPoolId, // Your user pool id here
          ClientId: UserActionCreator.AppClientId // Your client id here
        };
        const userPool = new CognitoUserPool(data)
        const cognitoUser = userPool.getCurrentUser()

        cognitoUser.signOut()
      } catch (e) {
        // tslint:disable-next-line:no-console
        console.error('Unable to log user out')
      }

      return Promise.resolve(
        { type: ActionTypes.LOGOUT }
      )
    })
  }

  confirm(username: string, confirmcode: string) {
    return this.dispatchAsync((getState) => {
      return new Promise((resolve, reject) => {
        try {
          const poolData = {
            UserPoolId: UserActionCreator.UserPoolId,
            ClientId: UserActionCreator.AppClientId
          }

          const userPool = new CognitoUserPool(poolData);
          const userData = {
            Username: username,
            Pool: userPool,
            GroupName: UserActionCreator.GroupName
          };

          const cognitoUser = new CognitoUser(userData);
          cognitoUser.confirmRegistration(confirmcode, true, (err, result) => {
            if (err) {
              reject(err)
            }
          })
        } catch (e) {
          reject(e)
        }

        return resolve(
          { type: ActionTypes.CONFIRM }
        )
      })
    })
  }

  register(username: string, password: string, firstname: string, lastname: string, email: string) {
    return this.dispatchAsync((getState) => {
      return new Promise((resolve, reject) => {
        try {
          const poolData = {
            UserPoolId: UserActionCreator.UserPoolId,
            ClientId: UserActionCreator.AppClientId
          }
          const userPool = new CognitoUserPool(poolData);

          const attributeList = []

          const dataEmail = {
            Name: 'email',
            Value: email
          }

          const dataFirstName = {
            Name: 'name',
            Value: firstname
          }

          const dataLastName = {
            Name: 'family_name',
            Value: lastname
          }

          const attributeEmail = new CognitoUserAttribute(dataEmail)
          const attributeFirstName = new CognitoUserAttribute(dataFirstName)
          const attributeLastName = new CognitoUserAttribute(dataLastName)

          attributeList.push(attributeEmail)
          attributeList.push(attributeFirstName)
          attributeList.push(attributeLastName)

          userPool.signUp(username, password, attributeList, null, (err, result) => {
            if (err) {
              return reject(err)
            } else {
              return resolve(
                { type: ActionTypes.REGISTER }
              )
            }
          });
        } catch (e) {
          return reject(e)
        }
      })
    })
  }
}

const UserActions = new UserActionCreator()

export {
  UserActions,
  UserActionCreator
}



// WEBPACK FOOTER //
// ./src/app/redux/User/actions/index.ts